import { ITimeFrameObject } from './i-time-frame-object';
import { ContentControlledEventActionEnum } from '../enums/content-controlled-event-action.enum';
import { ContentControlledMediaTypeEnum } from '../enums/content-controlled-media-type.enum';
import { ContentControlledKeyframe } from '../keyframe/content-controlled-keyframe';
import { ContentControlledEditingDirectiveInstructions } from './content-controlled-editing-directive-instructions';
import ContentControlSubtitlesContainer from '../subtitles/content-control-subtitles-container';

/** Actions that are configuration-complete without requiring instructions. */
const ACTIONS_COMPLETE_WITHOUT_INSTRUCTIONS: ReadonlySet<ContentControlledEventActionEnum> =
  new Set([
    ContentControlledEventActionEnum.BlackScreen,
    ContentControlledEventActionEnum.BlurScreen,
    ContentControlledEventActionEnum.PixelateScreen,
    ContentControlledEventActionEnum.Mute,
    ContentControlledEventActionEnum.Cut,
    ContentControlledEventActionEnum.Approve,
  ]);

export class ContentControlledEditingDirectiveViewModel
  implements ITimeFrameObject
{
  constructor(
    public id: number,
    public parentId: number,
    public mediaType: ContentControlledMediaTypeEnum,
    public startsAtMs: number,
    public endsAtMs: number,
    public title: string,
    public isApproved: boolean,
    public isMitigated: boolean,
    public startFrame: string,
    public endFrame: string,
    public keyframes: Array<ContentControlledKeyframe> = [],
    public action: ContentControlledEventActionEnum,
    public instructions?: ContentControlledEditingDirectiveInstructions,
    public subtitles?: ContentControlSubtitlesContainer,
    public createdAt?: number,
    public mediaId?: number,
  ) {}
  public get isConfigurationComplete(): boolean {
    return (
      ACTIONS_COMPLETE_WITHOUT_INSTRUCTIONS.has(this.action) ||
      (this.action !== ContentControlledEventActionEnum.Empty &&
        !this.instructions)
    );
  }
  public get IsEditSubtitleEvent() {
    return this.action === ContentControlledEventActionEnum.EditSubtitles;
  }
  public get durationMs() {
    return this.endsAtMs - this.startsAtMs;
  }
}
